<template>
  <div class="login">
    <login-header></login-header>
    <user-nav></user-nav>
    <!-- login下的子路由 -->
    <router-view></router-view>
    <login-footer></login-footer>
  </div>
</template>

<script>
import LoginHeader from '../common/Header.vue';
import UserNav from '../common/UserNav.vue';
import LoginFooter from '../common/LoginFooter.vue';

export default {
  name: 'Login',
  props: {
  },
  data() {
    return {
      
    }
  },
  components: {
    LoginHeader,
    UserNav,
    LoginFooter
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
